export enum CommentContentTypeEnum {
  /**Текст */
  Text = 'Text',
  /**Ссылка */
  Link = 'Link',
}
